export default "__VITE_ASSET__ca28dc2b__"